import { CARER_ROLE, COORDINATOR_ROLE, ORGANISATION_ADMIN_ROLE } from '@careapp-group/core';
import { PermissionDto } from '@careapp-group/ng-sdk';
import { createSelector } from '@ngrx/store';
import { OrganisationState } from '../organisations/organisations.reducer';
import { getConversationsState, getOrganisationState, getStreamState } from '../reducers';

export const userHasConversations = createSelector(
  getOrganisationState,
  (organisationState: OrganisationState) => {
    // These organisations have conversations enabled.
    const orgIdsWithConversations: string[] =
      organisationState?.ids?.reduce((acc, curr) => {
        const conversationsEnabled =
          organisationState?.configuration[curr]?.conversationsEnabled ?? false;
        if (conversationsEnabled) {
          return [...acc, curr];
        } else {
          return acc;
        }
      }, []) ?? [];

    // The user has a conversational role in the following organisations with conversations enabled.
    const conversationOrgsWithRoles = orgIdsWithConversations.reduce((acc, curr) => {
      if (
        // :TODO: (T Bowden, 21 March '22), this should use `CONVERSATIONS_ROLES` from ca-core
        organisationState.entities[curr]?.permissions?.some((permission) =>
          [ORGANISATION_ADMIN_ROLE, COORDINATOR_ROLE, CARER_ROLE].includes(
            // :TODO: (T Bowden 19 Sep '22), the swagger conversation of PermissionDto[]
            // to Array<String> needs to be fixed before removing this.
            (permission as unknown as PermissionDto).role
          )
        ) ??
        false
      ) {
        return [acc, curr];
      }
      return acc;
    }, []);

    return conversationOrgsWithRoles?.length > 0;
  }
);

export const conversationsLoading = createSelector(
  getConversationsState,
  getStreamState,
  (conversationsState, streamState) => conversationsState?.loading || streamState?.loading
);
export const conversationMembers = createSelector(
  getConversationsState,
  (conversationsState) => conversationsState?.members
);
export const conversationsUnreadCount = createSelector(
  getConversationsState,
  (conversationsState) => conversationsState?.unreadCount
);
